/**
* @feat <>
import { perfectRichTextImg } from "@/utils/other.js";
*/

import {
  IMG_HOST
} from '@/CONSTANT/common'

/**
 * @feat < 判断是否为手机设备 >
 */
export function isMobile() {
  return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
}

const bodyWidth = document.body.offsetWidth;

/**
 * @feat <完善富文本的图片>
 * @describe <加域名，cdn尺寸等>
 */
export function perfectRichTextImg(richText) {
  var content = richText.replace(/<img[^>]*>/gi, function (match) {
    let styleWidth

    match.replace(/(style="(.*?)")/gi, function ($1, $2, $3) {
      styleWidth = $3.replace(/(width: (.*?);)/gi, function ($1, $2, $3) {
        return $3
      })
    })

    let realImgWidth = bodyWidth

    if (styleWidth) {
      realImgWidth = styleWidth.replace(/(%|px)/, '')
    }

    match = match.replace(/(src="(.*?)")/gi, function ($1, $2, $3) {
      return `src="${/http/.test($3) ? $3 : IMG_HOST + $3}"?width=${realImgWidth}`;
    });
    return match;
  });
  return content;
}

// 打开QQ
export function openToQQChat(qqNum = 2976726787) {
  var u = navigator.userAgent;
  const isWechatBrowser =
    u.toLowerCase().match(/MicroMessenger/i) == "micromessenger";

  if (isMobile()) {
    if (isWechatBrowser) {
      alert('请使用系统自带浏览器本网站，再点击此按钮，方可QQ联系我们')
    } else {
      window.open(
        `mqqwpa://im/chat?chat_type=wpa&uin=${qqNum}&version=1&src_type=web`
      );
    }
  } else {
    window.open(
      `http://wpa.qq.com/msgrd?v=3&uin=${qqNum}&site=qq&menu=yes`
    );
  }
}